import { BookVisitPage } from '~/components/BookVisitPage/BookVisit'

export default function BookVisitRoutePage() {
  return <BookVisitPage />
}